import { render, staticRenderFns } from "./Paddle.vue?vue&type=template&id=be0e01d2&"
import script from "./Paddle.vue?vue&type=script&lang=js&"
export * from "./Paddle.vue?vue&type=script&lang=js&"
import style0 from "./Paddle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports